import { afterNextRender, Component, inject, Injector, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SystemPrompt } from 'src/app/models/system-prompt.interface';
import { PromptService } from 'src/app/services/prompt.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

type EditableSystemPrompt = SystemPrompt & { editing: boolean };
@Component({
  selector: 'app-manage-system-prompts',
  templateUrl: './manage-system-prompts.component.html',
  styleUrls: ['./manage-system-prompts.component.scss']
})
export class ManageSystemPromptsComponent implements OnInit {
  systemPrompts: EditableSystemPrompt[] = [];
  private _injector = inject(Injector);

  @ViewChild('autosize') autosize!: CdkTextareaAutosize;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private promptService: PromptService
  ) {}

  ngOnInit(): void {
    this.getSystemPrompts();
    console.log('Init from prompts component');
  }

  triggerResize() {
    // Wait for content to render, then trigger textarea resize.
    afterNextRender(
      () => {
        this.autosize.resizeToFitContent(true);
      },
      {
        injector: this._injector
      }
    );
  }

  getSystemPrompts() {
    console.log(' from getSystemPrompts subcribe');
    this.promptService.getSystemPrompts().subscribe({
      next: data => {
        if (!Array.isArray(data)) {
          console.error('Invalid response format:', data);
          return;
        }
        this.systemPrompts = data.map(prompt => ({
          ...prompt,
          editing: false
        }));
        console.log(this.systemPrompts);
      },
      error: error => {
        console.error('There was an error while fetching prompts: ', error);
      }
    });
  }

  resetPromptStates() {
    this.systemPrompts.forEach(prompt => (prompt.editing = false));
  }

  // Buttons per card
  onToggleEdit(id: number, editing: boolean) {
    this.systemPrompts = this.systemPrompts.map(prompt =>
      prompt.id === id ? { ...prompt, editing: editing } : prompt
    );
  }

  onSaveEdit({ id, name, arn, prompt_type, version, prompt }: SystemPrompt) {
    this.promptService.updateSystemPrompt({ id, name, arn, prompt_type, version, prompt }).subscribe({
      next: () => {
        this.snackBar.open('Prompt updated successfully', 'Close', {
          duration: 3000
        });
      },
      error: error => {
        console.error('There was an error while updating prompt: ', error);
        this.resetPromptStates();
      },
      complete: () => {
        console.log('Update prompt completed');
        // This will reset the editing state of the prompts
        this.getSystemPrompts();
      }
    });
  }
}
